export const apiTimeInterval = 30;     //seconds

export const BUTTON_STATE = {
    LIVE: 'live',
    VOD: 'vod',
    ENDED: 'ended',
    UNPUBLISHED: 'unpublished'
}